import React from 'react';
import MenuItemAnchor, {MenuItemAnchorProps} from './MenuItemAnchor';
import startsWith from 'lodash/startsWith';
import gettext from '../../utils/django/gettext';

const sharedProps = {
    children: gettext('Explore the Map'),
    href: '/map/',
};

function Toolbar(props: React.HTMLProps<HTMLAnchorElement>) {
    const isActive = startsWith(window.location.pathname, '/map/');

    return <a
        {...props}
        {...sharedProps}
        style={{
            ...props.style,
            borderBottomWidth: isActive ? 3 : 0,
            marginTop: isActive ? 3 : 0,
        }}
    />;
}


const HamburgerMenu = React.forwardRef(
    // eslint-disable-next-line prefer-arrow-callback
    function HamburgerMenuInner(props: MenuItemAnchorProps, ref: React.Ref<any>) {
        return <MenuItemAnchor ref={(ref as any)} {...props} {...sharedProps} />;
    }
);

export default {Toolbar, HamburgerMenu};
